import React from "react";

const LatestOrder = () => {
  return (
    <div className="container py-3">
      <div className="row">
        <h2 className="h2 order-title">Latest Orders</h2>
      </div>
      <div className="order-cont">
        <div className="row order-row d-flex align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <h3 className="h3 order-user">Wamae</h3>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <p className="order-amount">KES 20 000</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <p className="order-date">19/11/2022</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </div>
        </div>
        <hr className="order-hr" />
      </div>
      <div className="order-cont">
        <div className="row order-row d-flex align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <h3 className="h3 order-user">Wamae</h3>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <p className="order-amount">KES 20 000</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <p className="order-date">19/11/2022</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </div>
        </div>
        <hr className="order-hr" />
      </div>
      <div className="order-cont">
        <div className="row order-row d-flex align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <h3 className="h3 order-user">Wamae</h3>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <p className="order-amount">KES 20 000</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <p className="order-date">19/11/2022</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </div>
        </div>
        <hr className="order-hr" />
      </div>
      <div className="order-cont">
        <div className="row order-row d-flex align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <h3 className="h3 order-user">Wamae</h3>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <p className="order-amount">KES 20 000</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <p className="order-date">19/11/2022</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </div>
        </div>
        <hr className="order-hr" />
      </div>
      <div className="order-cont">
        <div className="row order-row d-flex align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <h3 className="h3 order-user">Wamae</h3>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <p className="order-amount">KES 20 000</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <p className="order-date">19/11/2022</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </div>
        </div>
        <hr className="order-hr" />
      </div>
      <div className="order-cont">
        <div className="row order-row d-flex align-items-center">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <h3 className="h3 order-user">Wamae</h3>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3">
            <p className="order-amount">KES 20 000</p>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <p className="order-date">19/11/2022</p>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1">
            <i class="fa fa-eye" aria-hidden="true"></i>
          </div>
        </div>
        <hr className="order-hr" />
      </div>
    </div>
  );
};

export default LatestOrder;
